export const en = {
  'sidebar.start': 'Start',
  'sidebar.setup': 'Setup',
  'sidebar.test01': 'Test01',
  'sidebar.test04': 'Test04',
  'sidebar.test05': 'Test05',
  'sidebar.test06': 'Test06',
  'sidebar.test07': 'Test07',
  'sidebar.live-chat': 'live chat',
  'sidebar.booking-confirmation': 'Confirmation',

  'start': 'start',
  'appointments': 'Appointments',
  'documents': 'Documents',
  'advice': 'guide and tips',

  'dashboard': 'dashboard',
  'profile': 'profile',
  'contact': 'Contact',
  'logout': 'logout',
  'login': 'login',
  'agenda': 'agenda',
  'single appointment': 'single appointment',
  'appointment chain': 'appointment chain',
  'confirmed': 'confirmed',
  'unconfirmed': 'not confirmed',
  'canceled': 'abgesagt',
  'no-show': 'no show',

  'jan': 'january',
  'feb': 'february',
  'mar': 'march',
  'apr': 'april',
  'may': 'may',
  'jun': 'june',
  'jul': 'july',
  'aug': 'august',
  'sep': 'september',
  'oct': 'october',
  'nov': 'november',
  'dec': 'december',

  ':weg': 'Dentist absent',
  ':room': 'Room unavailable',
  ':instr': 'Surgical instruments already in use',
  ':scan': 'Scanner already in use',
  ':endo': 'Endodontic motor already in use',
  ':cnc': 'Milling machine unavailable',
  ':opt': 'OPT/CBCT unit unavailable',

  'passwords_do_not_match': 'Passwords do not match',
  'user_already_registered': 'User already registered. Please login instead.',
  'registration_failed': 'Registration failed',
  'network_error': 'Network error',

  'swelling': 'Swelling',
  'dental pain': 'Dental pain',
  'bleeding': 'Bleeding',
  'broken tooth': 'Broken tooth',
  'lost filling': 'Lost filling',
  'lost crown or bridge': 'Lost crown or bridge',
  'problems after dental surgery': 'Problems after dental surgery',
  'sensitivity to hot or cold': 'Sensitivity to hot or cold',
  'braces or aligner emergency': 'Braces or aligner emergency',
  'left': 'left',
  'right': 'right',
  'upper': 'upper jaw',
  'lower': 'lower jaw',

  // TODO:
  'control-after-surgery': 'kontrolle nach Chirurgie',
  'control-general': 'allg. kontrolle',
  'control-impl-impression': 'kontrolle impl, Abformung',
  'control-periodontitis': 'kontrolle Paro',
  'control-prosthesis': 'kontrolle Prothetik',
  'croot-canal-filling': 'wurzelfüllung',
  'exam-aligner': 'befund Aligner',
  'extraction': 'ex',
  'extraction-8': 'opex 8er',
  'extraction-and-impl': 'ex, Implantation',
  'hand-over-aligner': 'übergabe Aligner',
  'hand-over-mich': 'abgabe mich',
  'hand-over-prothesis': 'abgabe',
  'impl': 'implantation',
  'impression': 'abformung',
  'impression-attachments-out': 'abformung, Attachments entfernen',
  'impression-bite-shade': 'abformung, Bissnahme, Farbwahl',
  'impression-indiv': 'abformung mit individuellem Löffel',
  'impression-mich': 'abformung mich',
  'pe-dressing': 'aufbereitung, Einlage',
  'prep-impression 120': 'präp, Abformung',
  'prep-impression-60': 'präp, Abformung 60',
  'prep-impression-cement': 'präp, Abformung, einsetzen',
  'prep-impression-prov-multi-tooth': 'präp, Abformung, provi mehrere Zähne',
  'prep-impression-prov-single-tooth': 'präp, Abformung, provi Einzelzahn',
  'prep-prov': 'präp, provi',
  'reg-wax-rim': 'registat mit Wachswall',
  'reserve-cementation': 'einsetzen Reservetermin',
  'retainer-in': 'retainer kleben',
  'root-canal-filling-prep-impression-prov': 'wurzelfüllung, präp, Abformung, provi',
  'second-dressing': 'einlage ii',
  'three-surface-filling': 'füllung 3-fl',
  'try-in-cementation': 'einprobe / einsetzen',
  'try-in-wax': 'einprobe in Wachs',
  'paro-surgery': 'parochirurgie',

  'description-emergency': 'Toothache, broken tooth, loose filling or crown',
  'description-dental-cleaning-DH-60': 'Professional dental cleaning for optimal oral hygiene and prevention',
  'description-exam-regular-patient': 'General check-up, assessment of oral mucosal, discolorations, and preventive care',
  'description-cons-8': 'Assessment and planning of wisdom tooth removal',
  'description-cons-aligner': 'Consultation on aligner therapies and options for teeth alignment correction',
  'description-cons-bleaching': 'Consultation on bleaching for a natural white smile',
  'description-cons-spint': 'Consultation on night guards, anti-snoring splints or sport guards',
  'description-cons-impl': 'Consultation on fixed dental prosthetics and modern implant solutions',
  'description-cons-aesth': 'Individual consultation on veneers, crowns, and aesthetic corrections',
  'description-second-opinion': 'Independent second opinion on an existing treatment plan',
  'description-exam-new-patient': 'Initial examination including general check-up, assessment of oral mucosa and preventive care. If needed, appointment scheduling for dental cleaning.',

  "no-appointments-available": "No appointments",
  "chain-date-range-short-hover": "The selected appointment is part of an appointment series and must take place between {from} and {to}.",
  "chain-hover-text": "Series",

};
